import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=542fa13a&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"
import style0 from "./introduce.vue?vue&type=style&index=0&id=542fa13a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542fa13a",
  null
  
)

export default component.exports